import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

export const ButtonIcon = styled(ButtonPlain).attrs({
	tabIndex: -1,
})`
	background-color: ${({ theme }) => theme.color.input.buttonIconBackground};
	border-radius: 0;
	min-width: 36px;
	padding: 0 8px;
	color: ${({ theme }) => theme.color.input.buttonIcon};
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: auto;
	transition: background-color 135ms ease, color 135ms ease;

	&:disabled {
		color: ${({ theme }) => theme.color.input.buttonIconDisabled};
	}

	&:hover:enabled,
	&:focus:enabled {
		color: ${({ theme }) => theme.color.input.buttonIconHover};
		background-color: ${({ theme }) => theme.color.input.buttonIconBackgroundHover};
	}
`
